import { makeStyles } from '@material-ui/core/styles';
import { MOBILE_BREAKPOINT } from '../../../../config/constants';

export const useStyles = makeStyles(theme => ({
    container: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        marginTop: '1rem',
        top: '1rem',
        marginBottom: '-1rem',
        [theme.breakpoints.down(MOBILE_BREAKPOINT)]: {
            marginTop: 0,
        },
        '& p': {
            fontWeight: 400,
            fontSize: 16,
        },
    },
}));
